// Módulo para interacciones con la API de Alcachofa (Flow y Shopify)
class AlcachofaAPI {
  constructor() {
    this.baseUrl = 'https://app.alcachofa.cl';
  }

  // Iniciar pago con Flow
  async iniciarPago(paymentData) {
    const response = await fetch(`${this.baseUrl}/flow-payment.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(paymentData)
    });

    if (!response.ok) {
      throw new Error('Error en la respuesta del servidor: ' + response.status);
    }

    return response.json();
  }

  // Crear orden en Shopify
  async crearOrdenShopify(shopifyData) {
    const response = await fetch(`${this.baseUrl}/create-shopify-order.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(shopifyData)
    });

    return response.json();
  }

  // Preparar datos de pago para Flow
  prepararDatosPago(ordenId, monto, email) {
    const commerceOrder = ordenId && ordenId.trim() !== '' ?
      ordenId + '-' + Date.now() + '-' + Math.floor(Math.random() * 1000) :
      'ST-' + Math.floor(10000 + Math.random() * 90000) + '-' + Date.now();

    const csrfToken = Date.now().toString(36) + Math.random().toString(36).substring(2);
    sessionStorage.setItem('flowCsrfToken', csrfToken);

    return {
      commerceOrder: commerceOrder,
      subject: 'Pago Servicio Técnico - Orden: ' + commerceOrder,
      currency: 'CLP',
      amount: monto,
      email: email,
      urlConfirmation: `${this.baseUrl}/flow-confirm.php`,
      urlReturn: `https://thorbenstore.cl/pages/servicio-tecnico?status=completed&orden=${ordenId}&token=${csrfToken}&amount=${monto}&email=${encodeURIComponent(email)}`,
      optional: {
        orden_id: commerceOrder,
        cliente_id: 'CL' + Math.floor(10000 + Math.random() * 90000),
        csrf_token: csrfToken
      },
      timeout: 600
    };
  }

  // Manejar respuesta de pago
  procesarRespuestaPago(data, ordenId, monto, email) {
    if (data.url) {
      sessionStorage.setItem('flowLastTransaction', JSON.stringify({
        order: data.commerceOrder || ordenId,
        amount: monto,
        timestamp: Date.now()
      }));
      
      setTimeout(() => { 
        window.location.href = data.url; 
      }, 1000);
    } else {
      const errorMsg = data.error || data.message || 'Error desconocido';
      throw new Error('Error al iniciar el pago: ' + errorMsg);
    }
  }
}

// Instancia global
window.alcachofaAPI = new AlcachofaAPI();